export enum CardsMessages {
  DEFAULT = 'No records found',
  VIEW_SUGGESTED_COMPLETED_ALL_SKILLS = 'Looks like you’ve completed all skills in this Roadmap. Go ahead and choose another one.',
  VIEW_SUGGESTED_COMPLETED_UNITS = 'Go you! You’ve completed all the skills for this Unit',
  VIEW_ALL__ALL_SKILLS = 'No skills to show. Try changing your filters',
}
